export const addRelationGroups = [{
    key: 'relation_group_name',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'relation_group_name',
        label: 'Name',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

}, {
    key: 'style_introduction_line',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'style_introduction_line',
        label: 'Style introduction line',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

}, {
    key: 'min_respondent',
    type: 'number',
    value: '',
    valid: false,
    elementConfig: {
        name: 'min_respondent',
        label: 'Min. Respondents ',
        placeholder: '1'
    },
    validation: {
        required: true,
        message: "is required"
    },

}, {
    key: 'default_enabled',
    type: 'checkbox',
    value: false,
    valid: true,
    elementConfig: {
        name: 'default_enabled',
        label: 'Default Enabled',
    },
    validation: {
        required: false,
        message: ""
    },
}, {
    key: 'relation_list',
    type: 'hidden',
    value: '',
    valid: true,
    elementConfig: {
        name: 'relation_list',
        label: '',
    },
    validation: {
        required: false,
        message: ''
    }
},]

export const addRelation = [
   
    {
        key: 'Boss',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Boss',
            label: 'Boss',
        },
        validation: {
            required: false,
            message: ""
        },

    }, {
        key: 'Cousin',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Cousin',
            label: 'Cousin',
        },
        validation: {
            required: false,
            message: ""
        },

    }, {
        key: 'Customer',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Customer',
            label: 'Customer',
        },
        validation: {
            required: false,
            message: ""
        },

    }, {
        key: 'Daughter',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Daughter',
            label: 'Daughter',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Direct Report',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Direct Report',
            label: 'Direct Report',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Friend',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Friend',
            label: 'Friend',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Mentee',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Mentee',
            label: 'Mentee',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Mentor',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Mentor',
            label: 'Mentor',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Parent',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Parent',
            label: 'Parent',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Partner',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Partner',
            label: 'Partner',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Peer',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Peer',
            label: 'Peer',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Sibling',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Sibling',
            label: 'Sibling',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Son',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Son',
            label: 'Son',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Spouse',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Spouse',
            label: 'Spouse',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Teacher',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Teacher',
            label: 'Teacher',
        },
        validation: {
            required: false,
            message: ""
        },
    }, {
        key: 'Vendor',
        type: 'checkbox',
        value: false,
        valid: true,
        elementConfig: {
            name: 'Vendor',
            label: 'Vendor',
        },
        validation: {
            required: false,
            message: ""
        },
    }]


// WEBPACK FOOTER //
// ./src/_pages/Admin/RelationGroups/relationGroupsFormData.js